import { render, staticRenderFns } from "./_siteWordpressPluginsView.vue?vue&type=template&id=25993df6"
import script from "./_siteWordpressPluginsView.vue?vue&type=script&lang=js"
export * from "./_siteWordpressPluginsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports